import { patch } from '@rails/request.js';

export function roundDecimal(num) {
  return +(Math.round(`${num}e+2`) + 'e-2');
}

const VALIDATION_PATHS = {
  'invoices-edit': (id) => `/invoices/${id}/xhr_validate_invoice`,
  'retainers-edit': (id) => `/retainers/${id}/xhr_validate_retainer`,
  'quotes-edit': (id) => `/quotes/${id}/xhr_validate_quote`,
  'purchase-orders-edit': (id) => `/purchase_orders/${id}/xhr_validate_purchase_order`,
  'spec-sheets-edit': (id) => `/spec_sheets/${id}/xhr_validate_spec_sheet`,
};

function validationUrl(form) {
  const billableId = form.getAttribute('action').split('/')[2];
  const build = VALIDATION_PATHS[document.body.id];
  return build ? build(billableId) : null;
}

export async function validateBillable(form) {
  const response = await patch(validationUrl(form), {
    body: new FormData(form),
    responseKind: 'json',
  });
  const data = (await response.json) || {};
  return { valid: !!data.valid, errorMessage: data.error_message };
}

export async function saveBillable(form) {
  const response = await patch(form.getAttribute('action'), { body: new FormData(form) });
  return response.ok;
}
